var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-cell"},_vm._l((_vm.tags),function(tag,index){return _c('VChip',{key:index,staticClass:"mr-1 mb-1",attrs:{"small":"","outlined":"","color":"secondary"}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }